document.addEventListener('DOMContentLoaded', function () {
    const footer = document.querySelector('.ktg__footer__container');
    console.log(footer, 'footer');
    if (!footer) return;
  
    let isMobileActive = false;
  
    function isMobile() {
      return window.innerWidth < 768;
    }
  
    function closeAllAccordions(titleAccordionClass = null) {
      const contents = footer?.querySelectorAll('.ktg-accordion__content');
      contents?.forEach(content => {
        if(content){
          if (!content.classList.contains(titleAccordionClass)) {
            content.style.maxHeight = null;
            content.classList.remove('is-open');
            const accordionClass = content.getAttribute('data-accordion-class');
            document.querySelector(`.${accordionClass}.ktg-accordion__title`)?.classList.remove('is-open');
            content.parentElement.classList.remove('open');
          }
        }
      });
    }
  
    function handleAccordionClick(e) {
      const title = e.target.closest('.ktg-accordion__title');
      if (!title || !isMobile()) return;
  
      // const content = title.nextElementSibling;
      const titleAccordionClass = title.getAttribute('data-accordion-class');
      const accordionContents = footer?.querySelectorAll(`.${titleAccordionClass}`);
      accordionContents?.forEach(accordionContent => {
        if (!accordionContent || !accordionContent.classList.contains('ktg-accordion__content')) return;
  
        if (accordionContent.classList.contains('is-open')) {
          accordionContent.style.maxHeight = null;
          accordionContent.classList.remove('is-open');
          title.classList.remove('is-open');
          accordionContent.parentElement.classList.remove('open');
        } else {
          closeAllAccordions(titleAccordionClass);
          accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
          accordionContent.classList.add('is-open');
          title.classList.add('is-open');
          accordionContent.parentElement.classList.add('open');
        }
      })
    }
  
    function setupAccordion() {
      // Close all by default
      closeAllAccordions();
      // Add event delegation if not already added
      if (!isMobileActive) {
        footer?.addEventListener('click', handleAccordionClick);
        isMobileActive = true;
      }
    }
  
    function teardownAccordion() {
      // Remove all open states and inline styles
      closeAllAccordions();
      // Remove event listener if present
      if (isMobileActive) {
        footer?.removeEventListener('click', handleAccordionClick);
        isMobileActive = false;
      }
    }
  
    function handleResize() {
      if (isMobile()) {
        setupAccordion();
      } else {
        teardownAccordion();
      }
    }

    function addCustomClassToParent(){
      const titles = footer?.querySelectorAll('.ktg-accordion__title');
      titles?.forEach(title => {
        title.parentElement?.classList.add('ktg-parent-panel');
      })
    }
  
    // Initial setup
    handleResize();
    window.addEventListener('resize', handleResize);
    addCustomClassToParent();
  }); 